<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  <ts-input
    type="money"
    [label]="fieldDef.label"
    [testId]="'form-field-' + fieldDef.name"
    [currencyCode]="currencyCode"
    [precision]="precision"
    [formControl]="control"
    (click)="edit()"
    (keyup.enter)="onBlur()"
    (blur)="onBlur()"
  />
</div>
